export default {
    namespaced: true,
    state: () => ({
        winW: 0,
        winH: 0,
    }),
    actions: {
        
    },
    mutations: {
        setItem(state, item){
            Object.keys(state).forEach((key) => {
                if(item[key]){
                    state[key] = item[key];
                }
            });
        },
    }
}

